import { movies, categories } from '@/mocks/movies';
import MovieCard from '@/components/feature/MovieCard';
import { Link } from 'react-router-dom';

export default function CategorySection() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="mb-8">
        <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">分类浏览</h3>
        <p className="text-sm text-foreground-500 mt-1">按类型探索丰富影视资源</p>
      </div>

      <div className="flex flex-col gap-10">
        {categories.map((cat) => {
          const catMovies = movies
            .filter((m) => m.category === cat.slug)
            .slice(0, 6);
          return (
            <div key={cat.slug}>
              <div className="flex items-center justify-between mb-5">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/15">
                    <i className={`${cat.icon} text-primary-500 text-lg`}></i>
                  </div>
                  <h4 className="font-heading text-lg font-bold text-foreground-900">{cat.name}</h4>
                  <span className="text-xs text-foreground-500 bg-background-200 px-2.5 py-0.5 rounded-full">
                    {movies.filter((m) => m.category === cat.slug).length}部
                  </span>
                </div>
                <Link
                  to={`/category/${cat.slug}`}
                  className="whitespace-nowrap flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer font-medium"
                >
                  全部 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
                {catMovies.map((movie) => (
                  <MovieCard key={movie.id} movie={movie} size="normal" />
                ))}
                <Link
                  to={`/category/${cat.slug}`}
                  className="w-[200px] h-[280px] flex flex-col items-center justify-center rounded-lg border-2 border-dashed border-background-300 hover:border-primary-400 hover:bg-background-200/50 transition-all cursor-pointer group"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-200 group-hover:bg-primary-500/15 transition-colors mb-3">
                    <i className="ri-add-line text-2xl text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
                  </div>
                  <span className="text-sm text-foreground-500 group-hover:text-primary-500 transition-colors font-medium">
                    查看更多
                  </span>
                </Link>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}